import { render, staticRenderFns } from "./DetailTopic.vue?vue&type=template&id=35bf3908&scoped=true&"
import script from "./DetailTopic.vue?vue&type=script&lang=js&"
export * from "./DetailTopic.vue?vue&type=script&lang=js&"
import style0 from "./DetailTopic.vue?vue&type=style&index=0&id=35bf3908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf3908",
  null
  
)

export default component.exports